import React, { useCallback, useRef } from "react";
import { ReplaceWithDataSource } from "../helpers/variable";

export default function UtilityLargeText({ cue }) {
	const textRef = useRef();
	const textLength = useCallback(() => {
		return textRef.current?.innerText?.length;
	}, []);

	return (
		<div className="w-screen h-screen flex items-center justify-center">
			<div
				ref={textRef}
				className={`flex items-center justify-center p-s4 m-s6 font-bold font-mono  rounded-ssm
				${textLength() > 100 && "text-s6xl"}
				${textLength() > 50 && textLength() <= 100 && "text-s8xl"}
				${textLength() <= 50 && "text-s10xl"}
				`}
			>
				<ReplaceWithDataSource text={cue?.text} styled={true} />
			</div>
		</div>
	);
}
